import { useEffect } from 'react';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { useOpenThreadsShallowStore } from '../open-threads-store';
import { MessagingUIType } from '../types';

export const useReportTimeToOpenToPendo = (lastSms: SMS | undefined, uiType: MessagingUIType, disable?: boolean) => {
  const { reportThreadOpen } = useOpenThreadsShallowStore('reportThreadOpen');

  useEffect(() => {
    if (!disable) {
      reportThreadOpen(lastSms, uiType);
    }
  }, [lastSms, uiType, disable, reportThreadOpen]);
};
